<template>
    <div class="Pay">
        <Header msg='支付详情'/>

        <div class="Pay-show flex flex-j-c-center">
            <span class="show-title">需支付金额(元)</span>
            <p>￥<span class="show-price">{{order_price || '0.00'}}</span></p>
        </div>

        <div class="Pay-method">
            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <p>优惠券</p>
                    <div class="flex flex-j-c-e method-right" @click="toCoupon">
                        <!-- <span style="color:#FABF01" v-if="pageData.is_coupon === 1">{{couponData.name || '暂无'}}</span> -->
                        <!-- <span style="color:#999999" v-if="pageData.is_coupon === 0">无可用</span> -->
                        <span style="color:#999999">无可用</span>
                        <img class="right-icon" :class="judge ? 'rightActive':''" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <div class="per-line" @click="show = true">
                <div class="flex flex-j-c-sb">
                    <p>支付方式</p>
                    <p style="color:#666666">微信支付</p>
                </div>
            </div>
        </div>

        <mt-button @click.native="handleClick" size="large" :class="btnJudge ? 'bgColor':''">确认支付￥{{order_price || '0.00'}}</mt-button>

        <van-popup
          v-model="show"
          lock-scroll
          @closed='toOrder'
          get-container="#app">
          <div class="pay-mask flex flex-j-c-center">
            <div class="mask-tips">
              <p class="mask-tips-title">上大学，到陈文卫教育</p>
              <p class="mask-tips-desc">恭喜您！已成功缴费！</p>
            </div>
            <img src="@/assets/qrcodestudent.png" style="width:2.50rem" class="mask-img"/>
            <p class="red">长按上方二维码</p>
            <p class="red">关注陈文卫成高服务号，开启学习之旅！</p>
          </div>
        </van-popup>

    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import {PaymentRelated} from '@/api';
import { Toast } from 'mint-ui';
import { Popup } from 'vant';

export default {
  name: 'Pay',
  components: {
    Header
  },
  data() {
    return {
      judge: false, // 选择优惠券按钮旋转控制（弃用）
      couponData: {name: '请选择'}, // 优惠券信息
      orderData: '', // 订单号
      pageData: {}, // 获取的订单信息
      order_price: '0.00', // 订单价格
      btnJudge: false, // 提交按钮是否不可用
      show: false, // 是否显示支付成功弹窗
      pid:'' // 教师预报名订单号
    }
  },
  created() {
    this.orderData = JSON.parse(sessionStorage.getItem('_needpayOrderNo')) || {};
    if (sessionStorage.getItem('_couponPay')) {
      this.couponData = JSON.parse(sessionStorage.getItem('_couponPay'));
    }
    // this.$route.query.previewId 存在，即为来自教师预报名
    this.pid = this.$route.query.previewId || '';
    if (this.pid) {
      this.orderData.order_no = this.pid
      this.orderData.key = 'k'
    }

    if (this.orderData.order_no) {
      let params = {order_no: this.orderData.order_no, type: 1, key: this.orderData.key}
      this.payMsg(params);
    } else {
      Toast({ message: '订单不存在，请稍后再试', duration: 1500 });
      this.btnJudge = true;
    }
  },
  methods: {
    // 确认支付
    handleClick() {
      let params = {};
      if (this.couponData.user_coupon_id) {
        params = {order_no: this.orderData.order_no, type: 2, coupon_id: this.couponData.user_coupon_id, key: this.orderData.key}
      } else {
        params = {order_no: this.orderData.order_no, type: 2, coupon_id:0, key: this.orderData.key}
      }
      
      this.payMsg(params);
    },
    // 跳转优惠券
    toCoupon() {
      // this.$router.push({name:'Coupon', query:{type: 'pay'}})
    },
    /**
     * 调用支付相关
     * tp 订单接口需要的数据（详情参考API文档）
     */
    payMsg(tp) {
      if (this.btnJudge) return false;
      this.btnJudge = true;
      PaymentRelated(tp).then(res => {
        if (res.code !== 0) { 
          if (res.code === 11) {
            Toast({ message: res.msg, duration: 15000 });
          } else {
            Toast({ message: res.msg, duration: 5000 });
            setTimeout(() => {
              let uid = JSON.parse(localStorage.getItem('cww_data')).id;
              window.location.href = `${window.location.origin}/home?id=${uid}`;
            }, 5000);
          }
        } else {this.pageData = res.data;}
        if (tp.type === 1) {
          if (this.couponData.user_coupon_id) {
            this.order_price = this.handlePrice(res.data.price, this.couponData.sub_price);
          } else {
            this.order_price = res.data.price;
          }
        } else {
          var url = `${window.location.origin}/Order`;
          if (this._tools.isWechat() && res.code === 0) {
            this._tools.wechatPayCallpay(res.data, url).then((e)=>{
              if(e) {this.show=true;}
            });
          } else {
            let str = '请在微信浏览器打开';
            if (res.code !== 0) { str = res.msg; }
            Toast({ message: str, duration: 1500 });
          }
        }
        this.btnJudge = false;
      })
    },
    /**
     * 处理价格
     * orPrice 原价格
     * coPrice 优惠价格
     */
    handlePrice(orPrice, coPrice) {
      let pri = 0;
      if (Number(orPrice) < Number(coPrice)) {
        Toast({ message: '所选优惠券金额不能大于订单金额', duration: 1500 });
        this.couponData = {name: '请选择'}
        sessionStorage.removeItem("_couponPay");
        pri = orPrice;
      } else {
        pri = orPrice - coPrice;
      }
      return Number(pri).toFixed(2);
    },
    // 跳转订单页
    toOrder() {
      window.location.href = `${window.location.origin}/Order`
    }
  }
};
</script>

<style scoped lang="less">
.Pay{
    min-height: 100vh;
    padding: 0.44rem 0 0.6rem;
    font-size: 0.16rem;
    .mint-button--large{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0.3rem;
    }
    .Pay-show{
        flex-direction: column;
        font-size: 0.18rem;
        background: white;
        padding: 0.25rem 0;
        border-top: 1px solid gainsboro;
        .show-title{
            font-size: 0.12rem;
            color: #666666;
            margin-bottom: 0.20rem;
        }
        .show-price{
            font-size: 0.3rem;
            color: #FABF01;
        }

    }
    .Pay-method{
        margin-top: 0.1rem;
        background: white;
        padding: 0 0.2rem;
        &>:last-child{
            border: none;
        }
    }
}
.van-popup--center{
  border-radius: 6px;
  width: 85%;
}
.mask-tips{
  background: #FABF01;
  color: white;
  padding: 0.2rem 0 0.1rem;
  .mask-tips-title{
    font-size: 0.2rem;
  }
}
.pay-mask{
  flex-direction: column;
  border-radius: 6px;
  padding-bottom: 0.1rem; 
  p{
    margin-bottom: 0.1rem;
  }
  .mask-img{
    margin: 0.05rem auto;
  }
}
.red{
  color: red;
  font-weight: bold;
}
</style>
